import script from "./SelectVue.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectVue.vue?vue&type=script&setup=true&lang=js"

import "./SelectVue.vue?vue&type=style&index=0&id=e0455054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0455054"]])

export default __exports__